import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { Button, styled } from '@mui/material'
import PropTypes from 'prop-types'


const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
})

const UploadButton = ({ label, accept, onUpload, ...props }) => {
    return (
        <Button
            name='uploadButton'
            startIcon={<CloudUploadIcon />}
            variant='contained'
            color='primary'
            component='label'
            role={undefined}
            onChange={onUpload}
            {...props}
        >
            {label}
            <VisuallyHiddenInput type='file' accept={accept} />
        </Button>
    )
}

UploadButton.propTypes = {
    label: PropTypes.string.isRequired,
    accept:PropTypes.string.isRequired,
    onUpload: PropTypes.func.isRequired
}

export default UploadButton
